'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var $ = require("jquery");
var Loading = /** @class */ (function () {
    function Loading() {
        if ($('.bulletLoadingTitle').length) {
            setTimeout(function () {
                $('.bulletLoadingTitle').fadeOut('slow');
            }, 2000);
        }
    }
    return Loading;
}());
exports.Loading = Loading;
exports.default = Loading;
